import { App } from "@capacitor/app"
import { Capacitor } from "@capacitor/core"
import { promiseTimeout } from "@vueuse/core"

const isNative = () => Capacitor.isNativePlatform()

const getVersion = async (): Promise<string> => {
  const appInfo = await App.getInfo()
  return appInfo.version
}

const getVersionWithTimeout = async (): Promise<string> => {
  const RESOLVE_TIMEOUT_MS = 1000
  return Promise.race([
    getVersion(),
    promiseTimeout(RESOLVE_TIMEOUT_MS).then(() => "unknown"),
  ])
}
/**
 * If window.mobileApp exists, that means we are currently inside an in-app
 * browser.
 **/
const isInAppBrowser = () => globalThis.mobileApp !== undefined

const isIframe = () =>
  window.frameElement !== null || globalThis.self !== globalThis.top

const getPlatform = () => Capacitor.getPlatform()

const isIos = () => getPlatform() === "ios"

const isAndroid = () => getPlatform() === "android"

const getVersionString = async (): Promise<string> => {
  const appInfo = await App.getInfo()

  return `v${appInfo.version} build ${appInfo.build}`
}

export default {
  isNative,
  isInAppBrowser,
  isIframe,
  getPlatform,
  isIos,
  isAndroid,
  getVersionString,
  getVersionWithTimeout,
}
